<template>

  <v-card style="box-shadow:none" class="order-rejection-form">

    <div style="font-size:1.2em;">Reason:</div>
    <v-radio-group row v-model="reason">
      <v-radio
          v-for="reason in reasonSelections"
          :key="reason.code"
          :label="reason.label"
          :value="reason.code" />
    </v-radio-group>
    <div class="mt-2">
      <v-textarea
          rows="1"
          label="Provide details for rejection."
          v-model.trim="notes" />
    </div>

    <!-- Actions -->
    <v-card-actions class="ma-0 pa-0 mt-8">
      <v-btn text @click="cancel">Cancel</v-btn>
      <v-spacer />
      <v-btn
          color="primary"
          class="pl-4 pr-4"
          :disabled="!notes || notes.length === 0"
          @click="rejectOrder">
        <span>Reject Order</span>
      </v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
export default {
  name: 'DeliveryOrderRejectionForm',

  data () {
    return {
      isProcessing: false,
      reason: 'delivery',
      notes: null
    }
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  computed: {
    reasonSelections () {
      return [
        { label: 'Order rejected by agent', code: 'delivery' }
      ]
    },
    receiverNotes () {
      return this.order.receiver_notes
    }
  },

  beforeMount () {
    this.notes = this.receiverNotes
  },

  methods: {
    clear () {
      this.reason = 'delivery'
      this.notes = null
    },

    cancel () {
      this.clear()
      this.$emit('canceled')
    },

    async rejectOrder () {
      this.$emit('rejected', {
        reason: this.reason,
        notes: this.notes
      })
    }
  }
}
</script>

<style>
</style>
